import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Num = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M8.44 6h3.48v23H7.913V10.736L3.797 12.79 2.004 9.21 8.441 6Zm13.503 4c-1.59 0-3.007 1.548-3.007 3h-4.009c0-3.519 3.071-7 7.016-7 3.67 0 7.015 2.717 7.015 6.5 0 1.512-.593 2.848-1.19 3.852-.566.95-1.241 1.773-1.685 2.312l-.083.102-.006.007-5.2 6.227h8.164v4h-14.03v-3.224l7.975-9.55.045-.055c.464-.566.967-1.178 1.373-1.861.426-.717.628-1.322.628-1.81 0-1.188-1.142-2.5-3.006-2.5Zm16.48-4c-3.567 0-6.458 2.885-6.458 6.444h4.009A2.447 2.447 0 0 1 38.424 10h.556a3.003 3.003 0 0 1 3.007 3c0 1.657-1.346 3-3.007 3h-2.004v4h2.004a3.003 3.003 0 0 1 3.007 3c0 1.657-1.346 3-3.007 3h-.556a2.447 2.447 0 0 1-2.45-2.444h-4.01c0 3.559 2.892 6.444 6.46 6.444h.556c3.875 0 7.016-3.134 7.016-7 0-1.959-.807-3.73-2.106-5a6.971 6.971 0 0 0 2.106-5c0-3.866-3.141-7-7.016-7h-.556ZM44 38H4a2 2 0 1 0 0 4h40a2 2 0 1 0 0-4Z"
            style={{ mixBlendMode: 'passthrough' }}
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
